import expressionStore from 'owa-expressions-store/lib/store/expressionStore';

export default function isExpressionPaneOpen(expressionId: string): boolean {
    return expressionId && expressionStore.expressionPickerViewStates.get(expressionId)?.isOpen;
}
